module.exports = __webpack_public_path__ + "fonts/museo-sans-500-webfont.2f768c5.woff";